module.exports = __webpack_public_path__ + "static/media/banner.7e86e723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sponsors/lezhin/banner.png
// module id = 95
// module chunks = 0